import type { Column } from "../components/ui/DataTable";

/** Escape één CSV-cel: quotes rond velden die komma/quote/newline bevatten. */
function esc(value: unknown): string {
  const s = String(value ?? "");
  if (/[",\n\r]/.test(s)) {
    return `"${s.replace(/"/g, '""')}"`;
  }
  return s;
}

/**
 * Exporteer rijen naar CSV en trigger een download (geen backend nodig).
 * BOM voorzorgt voor correcte Excel-weergave van €/é-tekens.
 */
export function exportRowsToCSV<T>(
  rows: T[],
  columns: Column<T>[],
  filename: string
): void {
  const header = columns.map((c) => esc(c.header)).join(",");
  const body = rows
    .map((row) => columns.map((c) => esc(c.accessor(row))).join(","))
    .join("\r\n");

  const csv = "﻿" + header + "\r\n" + body + "\r\n";
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename.endsWith(".csv") ? filename : `${filename}.csv`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}

/** Bouw de CSV-tekst (zonder download) — gebruikt door de mail-export. */
export function buildCsvText<T>(rows: T[], columns: Column<T>[]): string {
  const header = columns.map((c) => esc(c.header)).join(",");
  const body = rows
    .map((row) => columns.map((c) => esc(c.accessor(row))).join(","))
    .join("\r\n");
  return "﻿" + header + "\r\n" + body + "\r\n";
}